import { useMutation } from '@tanstack/react-query';
import { useApi } from '@/hooks/useApi';
import { useConfig } from '../useConfig';

export const useSwishPayment = () => {
  const apiFetch = useApi();
  const { urls } = useConfig();

  const fetchQrCode = useMutation<Blob, Error, { token: string }>({
    mutationFn: async ({ token }) => {
      const response = await apiFetch<Blob>(
        `${urls?.akovaPay}/v1/paymentsession/qr?token=${encodeURIComponent(token)}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response;
    }
  });

  const getSwishAppUrl = (token: string, redirection: string) => {
    const urlParams = new URLSearchParams(new URL(redirection).search);
    const callbackUrl = urlParams.get('ret');
    vtlog('Redirection URL:', redirection);

    if (!callbackUrl) {
      return undefined;
    }

    return `swish://paymentrequest?token=${encodeURIComponent(token)}&callbackurl=${encodeURIComponent(callbackUrl)}`;
  };

  return {
    fetchQrCode,
    getSwishAppUrl
  };
};
